// ProtectedRoute.js
import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import axios from "axios";

const ProtectedRoute = ({ children }) => {
  const baseURL = process.env.REACT_APP_BASE_URL;

  const [isAuthenticated, setIsAuthenticated] = useState(null); // Initially null until check completes

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await axios.get(`${baseURL}/checkAuth`, {
          withCredentials: true,
        });
        if (response.status === 200) {
          setIsAuthenticated(true); // User is authenticated
        }
      } catch (error) {
        setIsAuthenticated(false); // User is not authenticated
      }
    };

    checkAuth();
  }, []); // Empty dependency array to run on mount

  if (isAuthenticated === null) {
    return <div>Loading...</div>; // Show loading state while checking
  }

  return isAuthenticated ? children : <Navigate to="/auth/login" />;
};

export default ProtectedRoute;
